import { makeFrame, makeButton, literal_price } from 'ui_commons'

// look library/button.js    this.enabled;  this._normalTexture = normalTexture;  this._disabledTexture = disabledTexture;
export function createButton (parent, x, y, textureFolder, sndBtnClick, isIncludeDisableTexture = false) {

    let description = {
        frames:{
            normal:     textureFolder + "/up.png",
            pressed:    textureFolder + "/down.png",
            hover:      textureFolder + "/over.png"
        },
        position:{x: x, y: y}
    };

    if (isIncludeDisableTexture) {
        description.frames.disabled = textureFolder + "/disabled.png";
    }

    let button = makeButton(description);

    if (sndBtnClick) {
        button.on('pointerdown', function() {sndBtnClick.play()});
    }

    parent.addChild(button);

    return button;
}

// если дробная часть нулевая, то отображаем только целую
export function literal_price_with_check_zero_fractional_part(value, precision, delimiter, isAlwaysShowFractionalPart = false)
{
    if (precision) {
        // precision задано числом знаков после запятой(1, 2, 3 ..)
        const precision_multiplier = Math.pow(10, precision);
        // если остаток от деления не ноль, то присутствует дробная часть(копейки, центы)
        if (value % precision_multiplier > 0 || isAlwaysShowFractionalPart) {
            return literal_price(value, precision, delimiter);
        }
        else {
            return value > 0 ? value.toString().slice(0, -precision) : value;
        }
    }
    return value;
}

// округлить поумолчанию(isUp = true) к БОЛЬШЕМУ целое представление с заданной точностью(round_price(50, 100); return: 100)
export function round_price(value, precision, isUp = true)
{
    if (precision) {
        // если precision задано числом знаков после запятой(1, 2, 3 ..)
        // const precision_multiplier = Math.pow(10, precision);
        // если precision задано множителем(10, 100, 1000 ..)
        const precision_multiplier = precision;
        // to float
        value = isUp ? Math.ceil(value / precision_multiplier) : Math.floor(value / precision_multiplier);
        // to integer
        value *= precision_multiplier;
    }
    return value;
}


//////////////////
// WEBPACK FOOTER
// ./src/common/ui.js
// module id = 15
// module chunks = 0